import { useStore } from "..";
export const useSignUp = () => useStore(({ signUp }) => signUp);
